import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useToggle } from 'react-use';
import { Button } from '@mui/material';
import { CSVDialog } from '@e2m-customer-portal/ui';

export function CSVDownloadButton(): ReactElement {
  const [t] = useTranslation();
  const [isOpen, toggleOpen] = useToggle(false);

  return (
    <>
      <Button onClick={toggleOpen}>{t('CSV_DOWNLOAD_BUTTON')}</Button>
      <CSVDialog open={isOpen} onClose={toggleOpen} />
    </>
  );
}
